"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputControl = void 0;
const react_1 = __importStar(require("react"));
const chakra_lib_components_field_error_1 = require("@eqg/chakra-lib.components.field-error");
const chakra_lib_components_field_helper_1 = require("@eqg/chakra-lib.components.field-helper");
const react_2 = require("@chakra-ui/react");
function InputControl(_a) {
    var { children, dir = "column", error, errorMt = "8px", helperText, helperTextMt = "8px", helperTextProps, isDisabled, isLoading, label, labelHelper, labelProps, register } = _a, rest = __rest(_a, ["children", "dir", "error", "errorMt", "helperText", "helperTextMt", "helperTextProps", "isDisabled", "isLoading", "label", "labelHelper", "labelProps", "register"]);
    const errorMessage = react_1.useMemo(() => {
        if (typeof error === "string") {
            return error;
        }
        return null;
    }, [error]);
    return (react_1.default.createElement(react_2.FormControl, Object.assign({ alignItems: dir === "row" ? "center" : "flex-start", display: "flex", flexDirection: dir }, rest),
        label && (react_1.default.createElement(react_2.FormLabel, Object.assign({ color: "darkgray.700", fontSize: "1rem", marginBottom: dir === "row" ? "0px" : "12px", textStyle: "label", fontWeight: "semibold" }, labelProps),
            label,
            labelHelper && (react_1.default.createElement(react_2.chakra.span, { fontWeight: "medium", color: "darkgray.700" }, labelHelper)))),
        react_1.createElement(children.type, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, children.props), register), (error && { error: error })), (isLoading && { isLoading: isLoading })), (isDisabled && { isDisabled: isDisabled }))),
        errorMessage && !isLoading && (react_1.default.createElement(chakra_lib_components_field_error_1.FieldError, { message: errorMessage, marginTop: errorMt })),
        helperText && (react_1.default.createElement(chakra_lib_components_field_helper_1.FieldHelper, Object.assign({ marginTop: helperTextMt }, helperTextProps), helperText))));
}
exports.InputControl = InputControl;
//# sourceMappingURL=InputControl.js.map